const initFooterBar = () => {

  function renderWidget() {
    window.Trengo.Api.Widget.render();
  }

  function openChat() {
    const type = window.innerWidth < 768 ? 'chat' : 'chat';
    window.Trengo.Api.Widget.open(type);
  }

  function openWidget() {
    document.getElementById('trengo-web-widget').style.display = 'block';
    if (!window.Trengo.render) {
      window.Trengo.render = true;
      renderWidget();
      setTimeout(() => {
        openChat();
      }, 0);
    } else {
      openChat();
    }
  }

  function findAncestorWithDataId(element) {
    while (element && !element.hasAttribute('data-id')) {
      element = element.parentElement;
    }
    return element ? element.getAttribute('data-id') : null;
  }

  function toggleShowClass(event) {
    event.preventDefault();
    const targetElement = event.target.closest('[data-loyalty], [data-lion-points]');
    if (targetElement) {
      const dataId = findAncestorWithDataId(targetElement);
      const matchingElement = document.getElementById(dataId);
      if (matchingElement && !matchingElement.classList.contains('show')) {
        matchingElement.classList.add('show');
      } else if (matchingElement) {
        matchingElement.classList.remove('show');
      }
    }
  }

  function handleClickOutside(event) {
    const targetElement = event.target.closest('[data-loyalty], [data-lion-points]');
    if (!targetElement) {
      const matchingElement = document.querySelector('.information-container');
      if (matchingElement && matchingElement.classList.contains('show')) {
        matchingElement.classList.remove('show');
      }
    }
  }

  if (document.querySelector('.footer-bar')) {
    const JS_HOOK_CHAT = '[js-hook-chat]';
    const chatButton = document.querySelector(JS_HOOK_CHAT);
    window.Trengo = window.Trengo || {};
    window.Trengo.key = document.querySelector('.live-chat').getAttribute('data-key');

    window.Trengo.on_status_online = function () {
      const onlineMessage = document.querySelector('.live-chat').getAttribute('data-status');
      chatButton.innerText = onlineMessage;
    };

    window.Trengo.render = false;

    (function (d, script, t) {
      script = d.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://static.widget.trengo.eu/embed.js';
      d.getElementsByTagName('head')[0].appendChild(script);
    }(document));

    window.Trengo.on_ready = function () {
      chatButton.addEventListener('click', () => openWidget());
      window.Trengo.on_close = function() {
        document.getElementById('trengo-web-widget').style.display = 'none';
      };
    };

    document.addEventListener('click', function(event) {
      if (window.innerWidth >= 1024) {
        const target = event.target;
        if (target.matches('[data-loyalty], [data-lion-points]')) {
          toggleShowClass(event);
        } else {
          handleClickOutside(event);
        }
      }
    });
  }
};

export default initFooterBar;
